import { isBusinessTypeId, type BusinessTypeId } from "./business-types.js";

/** ACT-05: the nav terms an account type may rename (each maps to a feature key / route). */
export const LABEL_TERMS = ["contacts", "pipeline"] as const;
export type LabelTerm = (typeof LABEL_TERMS)[number];

const NS = "dashboard.nav.typeLabels";

/** Types that override a term; the i18n key is `dashboard.nav.typeLabels.<type>.<term>`. */
const OVERRIDES: Partial<Record<BusinessTypeId, readonly LabelTerm[]>> = {
  restaurant: ["contacts"],
  clinic: ["contacts"],
  salon: ["contacts"],
  car_workshop: ["contacts"],
  real_estate: ["contacts", "pipeline"],
  travel: ["contacts"],
  retail_shop: ["contacts"],
};

/**
 * i18n key overrides for a few nav terms of the account type; terms not listed keep their default
 * label. `general`, unknown or absent types return `{}`.
 */
export function labelsFor(type: string | null | undefined): Partial<Record<LabelTerm, string>> {
  if (!isBusinessTypeId(type)) return {};
  const out: Partial<Record<LabelTerm, string>> = {};
  for (const term of OVERRIDES[type] ?? []) out[term] = `${NS}.${type}.${term}`;
  return out;
}
